import React, { Component } from 'react';
import { connect } from 'react-redux';

import { domainActions } from '../../../_actions';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class DomainRegistrationComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      url: "",
      submitted: false
    }

    this.domainRegistrationModal = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();

    const { dispatch } = this.props;
    const { name, url } = this.state;

    let informedUrl = url;

    let urlPattern = new RegExp(/^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/);

    if ( !name || name === "" ) {
      return toast.error('Por favor, informe um nome válido.', {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-error'
      });
    }

    if ( !urlPattern.test(informedUrl) ) {
      return toast.error('Por favor, informe uma URL válida contendo HTTPS.', {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-error'
      });
    }

    if ( informedUrl.indexOf('https://') !== 0 ) {
      let oldUrl = informedUrl;
      informedUrl = `https://${oldUrl}`;
    }

    if ( name && informedUrl ) {
      let _ = this;
      dispatch(domainActions.insertDomain(name, informedUrl))
        .then(res => {

          if ( res.type === 'STATUS_REGISTER_DOMAIN_FAILURE' ) {
            return toast.error(res.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              className: 'toast-error'
            });
          }

          _.domainRegistrationModal.current.click();
          dispatch(domainActions.getDomainsByToken())
            .then(async res => {
              if ( res.type === 'DASHBOARD_VERIFY_DOMAIN_SUCCESS' ) {
                this.handleCloseModal();
                
                this.props.handleDomainReload(null, true);
                
                this.props.reloadSidebar();
              }
            })
        });
    }
  }

  handleCloseModal = e => {
    this.setState({name: '', url: ''});

    document.getElementById('name').value = '';

    document.getElementById('url').value = '';
  }

  render() {
    const { submitted, name, url } = this.state;

    return(
      <div className="modal fade" id="domainRegistrationModal" tabIndex="-1" role="dialog" aria-labelledby="domainRegistrationModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <p className="title">Adicionando um novo domínio</p>
              <p className="disclaimer">Informe abaixo um nome identificador para seu domínio e a URL do seu domínio contendo HTTPS.</p>
              <button type="button" className="close" ref={this.domainRegistrationModal} onClick={this.handleCloseModal} data-dismiss="modal" aria-label="Close">
                <i className="lnr lnr-cross"></i>
              </button>

              <form action="#" className="form" id="domainRegistrationForm" method="POST" onSubmit={this.handleSubmit}>
                <div className="content-group">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className={submitted && !name ? 'form-control form-control-error' : 'form-control'}
                      autoComplete="off"
                      onChange={this.handleChange}
                      defaultValue={name}
                    />
                    <label htmlFor="name">Nome do Domínio</label>
                    {submitted && !name && <div className="input-error">Por favor, informe o nome do domínio.</div>}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="url"
                      id="url"
                      className={submitted && !url ? 'form-control form-control-error' : 'form-control'}
                      onChange={this.handleChange}
                      defaultValue={url}
                    />
                    <label htmlFor="url">URL do Domínio</label>
                    {submitted && !url && <div className="input-error">Por favor, informe a URL do domínio</div>}
                  </div>
                </div>

                <button type="submit" className="btn btn-blue float-right">
                  <i className="linearicons-plus"></i> Adicionar domínio
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { registerDomain } = state.storeDomainReducer;
  return registerDomain;
}

const ConnectedDomainRegistrationComponent = connect(mapStateToProps)(DomainRegistrationComponent);
export { ConnectedDomainRegistrationComponent as DomainRegistrationComponent }